import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { R300 } from '@atlaskit/theme/colors';
import ErrorIcon from '@atlaskit/icon/glyph/error';
import Button from '@atlaskit/button/custom-theme-button';
import { Frame } from '../Frame';
import { IconAndTitleLayout } from '../IconAndTitleLayout';
import { AKIconWrapper } from '../Icon';
import { messages } from '../../../messages';
import { FormattedMessage } from 'react-intl-next';
import { IconStyledButton } from '../styled';
import withFrameStyleControl from '../utils/withFrameStyleControl';
import { HoverCard } from '../../HoverCard';
export class InlineCardErroredView extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "frameRef", /*#__PURE__*/React.createRef());
    _defineProperty(this, "handleRetry", event => {
      const {
        onRetry
      } = this.props;
      if (onRetry) {
        event.preventDefault();
        event.stopPropagation();
        onRetry();
      }
    });
    _defineProperty(this, "renderActionButton", () => {
      const {
        onRetry
      } = this.props;
      const ActionButton = withFrameStyleControl(Button, this.frameRef);
      return onRetry && /*#__PURE__*/React.createElement(ActionButton, {
        spacing: "none",
        component: IconStyledButton,
        onClick: this.handleRetry,
        role: "button"
      }, /*#__PURE__*/React.createElement(FormattedMessage, messages.try_again));
    });
  }
  render() {
    const {
      url,
      onClick,
      isSelected,
      testId = 'inline-card-errored-view',
      icon,
      message
    } = this.props;
    const content = /*#__PURE__*/React.createElement(Frame, {
      testId: testId,
      isSelected: isSelected,
      ref: this.frameRef
    }, /*#__PURE__*/React.createElement(IconAndTitleLayout, {
      icon: icon || /*#__PURE__*/React.createElement(AKIconWrapper, null, /*#__PURE__*/React.createElement(ErrorIcon, {
        label: "error",
        size: "small",
        primaryColor: `var(--ds-icon-danger, ${R300})`,
        testId: "errored-view-default-icon"
      })),
      link: url,
      title: url,
      onClick: onClick,
      rightSide: message
    }), this.renderActionButton());
    if (this.props.showHoverPreview) {
      return /*#__PURE__*/React.createElement(HoverCard, {
        url: url
      }, content);
    }
    return content;
  }
}